var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { StyledIcon } from '../components/StyledIcon';
export var Monitoring = forwardRef(function (props, ref) { return (_jsx(StyledIcon, __assign({ ref: ref, viewBox: "0 0 30 30", a11yTitle: "Monitoring" }, props, { children: _jsx("path", { d: "M4.38461 3.15771C3.08384 3.15771 2.03027 4.21128 2.03027 5.51205V19.6381C2.03027 20.9388 3.08384 21.9924 4.38461 21.9924H12.6248V24.3467H10.2704V26.7011H19.6878V24.3467H17.3334V21.9924H25.5736C26.8744 21.9924 27.9279 20.9388 27.9279 19.6381V5.51205C27.9279 4.21128 26.8744 3.15771 25.5736 3.15771H4.38461ZM4.38461 5.51205H25.5736V19.6381H4.38461V5.51205Z", fill: "#000" }) }))); });
//# sourceMappingURL=Monitoring.js.map